import * as React from "react"
import TemplateV2 from "../../../components/builder/templates/TemplateV2"
import { TEMPLATE_ID } from "./config/template-id"
import "./overrides.css"

/**
 * Squareline: Free Template 1 with square corners.
 *
 * It draws inside its own wrapper (`lib-squareline`) and overrides.css only styles inside that wrapper. Written against the bare
 * `.mk-v2`, the overrides also changed Free Template 1, whose root is the same class, and the two looked identical.
 */
const entry = {
  id: TEMPLATE_ID,
  worth: 80000,
  label: "Library Template 1",
  blurb: "Square-edged variation of Free Template 1.",
  premium: true,
  from: "library/template-1",
  ported: true,
  Component: props => (
    <div className="lib-squareline">
      <TemplateV2 {...props} />
    </div>
  ),
}

export default entry
